import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.useCart'

export default defineMessages({
  setQuantity: {
    id: `${scope}.setQuantity`,
    defaultMessage: 'Set the quantity of "{name}" to {quantity}.',
  },
  removeItem: {
    id: `${scope}.removeItem`,
    defaultMessage: 'Remove "{name}" from my cart.',
  },
  continueToOrderRequest: {
    id: `${scope}.continueToOrderRequest`,
    defaultMessage: 'Continue to the order request form.',
  },
  preparingCheckout: {
    id: `${scope}.preparingCheckout`,
    defaultMessage: 'Preparing your checkout…',
  },
})
